import storageSession from "redux-persist/lib/storage/session";
import {createSlice} from "@reduxjs/toolkit";
import {persistReducer} from "redux-persist";
import publicRuntimeConfig from "@FRAMEWORK/config/public";

type StoreGoodsFilterListType = {
	[dspSid: string]: Array<{key: string; text: string; value: string; asc?: boolean}>;
};

type StoreGoodsFilterType = {
	goodsFilter: StoreGoodsFilterListType;
};

const initialState: StoreGoodsFilterType = {goodsFilter: {}};

const sliceStore = createSlice({
	name: "goodsFilter",
	initialState,
	reducers: {
		setGoodsFilter: (state, action: {payload: StoreGoodsFilterListType}) => {
			const {payload} = action;
			state.goodsFilter = {...state.goodsFilter, ...payload};
		},
		initGoodsFilter: () => initialState,
	},
});

const sessionPersistConfig = {
	key: `$$YBSESSION_PRDT_FILTER_${publicRuntimeConfig.RUNTIME_ENV}`,
	storage: storageSession,
};

export const {setGoodsFilter, initGoodsFilter} = sliceStore.actions;
export default persistReducer(sessionPersistConfig, sliceStore.reducer);
